import React from 'react';

import { Geometry } from '../../../../../../viewer/elements/geometry';
import { useNonce } from '../../../../../hooks/use-nonce';
import { useAsset } from '../../../hooks/use-asset';
import { CategoryContext } from '../../../state/category-state';
import { Asset } from '../../components/asset-blocks/asset';
import { LineBody } from './line-body';
import { LineHeader } from './line-header';

type Props = {
  asset: Geometry;
};

const LineAsset = (props: Props) => {
  const { refreshAssets } = React.useContext(CategoryContext);
  const [_, refresh] = useNonce();
  const { assetSelected } = useAsset(props.asset, {
    onAssetChanged: () => {
      // Rerender assets when line turns into an area.
      if (props.asset.isArea) {
        refreshAssets();
      }

      refresh();
    },
  });

  React.useEffect(() => {
    // Automatically load the asset when it is selected if it's not already loaded.
    if (assetSelected && props.asset.isReadyToLoad()) {
      props.asset.loadGeometry();
      refresh();
    }
  }, [assetSelected, props, props.asset, refresh]);

  React.useEffect(() => {
    props.asset.onMetaDataUpdated = refresh;

    return () => {
      props.asset.onMetaDataUpdated = undefined;
    };
  }, [props.asset, refresh]);

  return (
    <Asset asset={props.asset}>
      {{
        header: <LineHeader asset={props.asset} />,
        content: <LineBody asset={props.asset} refreshAsset={refresh} />,
      }}
    </Asset>
  );
};

export { LineAsset };
